import { ReactNode } from 'react';
import classnames from 'classnames';

import type { Icon } from '@personly/libs-types';

import { IconView } from '../index.js';

const className = classnames('flex', 'flex-row');

const makeIconClassName = (collapse: boolean) =>
  classnames({
    'mr-0': collapse,
    'mr-2': !collapse,
    'cursor-pointer': true,
    'md:!mr-2': true,
  });

const makeChildClassName = (collapse: boolean) =>
  classnames({
    hidden: collapse,
    flex: !collapse,
    'md:!flex': true,
  });

interface Props {
  children: ReactNode;
  collapse?: boolean;
  icon?: Icon;
  size?: string;
}

const NavLink = ({ children, collapse = false, icon, size }: Props) => (
  <div className={className}>
    <div data-testid="navlink-icon" className={makeIconClassName(collapse)}>
      <IconView icon={icon} fixedWidth size={size} />
    </div>
    <div
      data-testid="navlink-children"
      className={makeChildClassName(collapse)}
    >
      {children}
    </div>
  </div>
);

NavLink.displayName = 'NavLink';

export default NavLink;
